import React, { useEffect, useRef, useState } from "react";
import Block from "../Blocks/block";
import ContentWrapper from "../Blocks/contentWrapper";
import SectionWrapper from "../Blocks/sectionWrapper";
import BlockContent from "../Blocks/blockContent";
import Title from "../Blocks/title";
import Paragraph from "../Blocks/paragraph";
import { EColor, EIconGlyph, ESize, MFontSizeProperties } from "../../styleConstants";
import TextField from "../Blocks/textField";
import Button from "../Blocks/button";
import copy from 'copy-to-clipboard';
import Translate from "../Translate";
import LocaleImage from "../Blocks/localeImage";
import { rem, useIsMobile } from "../styleUtils";
import DisabledContent from "../Blocks/disabledContent";
import { shareWithAPI } from "./apiShare";


function shareDetails (link: string) {
    const facebook = Translate.path("views.site_pages.refer_a_friend_v2.facebook_link", { onclick: `socialSharer('${link}','','facebook')` } )

    const email = Translate.path("views.site_pages.refer_a_friend_v2.mail_link", { 
        subject: Translate.path("views.site_pages.refer_a_friend_v2.mail_subject"),
        body: Translate.path("views.site_pages.refer_a_friend_v2.mail_body"),
        link: link
    })

    return (
        <Translate path="views.site_pages.refer_a_friend_v2.alternative_share" interpolation={{
            facebook: facebook,
            email: email
        }} />
    )
}

export default function FriendReferralHero ({
    referralLink,
    referralId,
    tag,
    stepperStart,
    linkHowItWorks = false
}: {
    referralLink: string
    referralId: string
    tag: string
    stepperStart?: React.MutableRefObject<HTMLDivElement>
    linkHowItWorks?: boolean
}) {
    const [shareAPIavailable, setShareAPIavailable] = useState<boolean>(false);
    const isMobile = useIsMobile()
    const [linkCopied, setLinkCopied] = useState<boolean>(false)
    
    useEffect(() => {
        setShareAPIavailable(navigator["share"] ? true : false)
    }, [])
    
    return (
        <SectionWrapper background={isMobile ? EColor.None : EColor.HeroGradientRussianOrange}>
            <ContentWrapper>
                <Block>
                    <BlockContent bleed="right">
                        <Title size={8} margin={ESize.small}>
                            <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.title`} />
                        </Title>

                        <Paragraph size={6} margin={ESize.small}>
                            <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.subtitle`} />
                        </Paragraph>

                        {linkHowItWorks ? 
                            <Paragraph size={5} margin={ESize.medium} weight={700} color={EColor.SunglowYellow}>
                                <a href="/accounts/refer_friend">
                                    <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.how_it_works_link`} />
                                </a>
                            </Paragraph>
                        :
                            <Paragraph size={5} margin={ESize.medium} weight={700} color={EColor.SunglowYellow}>
                                <span style={{cursor: "pointer"}} onClick={() => { stepperStart.current.scrollIntoView({behavior: "smooth", block: "center"}) }}>
                                    <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.how_it_works_link`} />
                                </span>
                            </Paragraph>
                        }

                        {shareAPIavailable && !isMobile ? 
                            <TextField 
                                name="inviteLinkAPI"
                                defaultValue={referralLink}
                                readOnly={true} 
                                trailingButton={Translate.path("views.site_pages.refer_a_friend_v2.share")}
                                onClickTrailingButton={() => {
                                    shareWithAPI(referralLink)
                                }}
                            />
                        :
                            <TextField 
                                name="inviteLink"
                                defaultValue={referralLink}
                                readOnly={true} 
                                trailingButton={
                                    linkCopied 
                                        ? Translate.path("views.site_pages.refer_a_friend_v2.copied")
                                        : Translate.path("views.site_pages.refer_a_friend_v2.copy")
                                }
                                trailingButtonBackground={linkCopied ? EColor.FruitSaladGreen : EColor.SunglowYellow}
                                onClickTrailingButton={() => {
                                    copy(referralLink)
                                    setLinkCopied(true)
                                }}
                            />
                        }

                        
                        <DisabledContent disableWhen="mobile">
                            <Paragraph size={6} margin={ESize.small}>
                                {shareAPIavailable ? "" : shareDetails(referralLink)}
                            </Paragraph>
                        </DisabledContent>

                        
                        <DisabledContent disableWhen="desktop">
                            <div onClick={() => { shareWithAPI(referralLink) }}>
                                <Button 
                                    type="primary" 
                                    label={Translate.path("views.site_pages.refer_a_friend_v2.share")}
                                    icon={EIconGlyph.share_ios}
                                />
                            </div>
                        </DisabledContent>

                        <Paragraph size={2} margin={ESize.small} color={EColor.MountainGray}>
                            <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.disclaimer`} />
                        </Paragraph>
                    </BlockContent>

                    <DisabledContent disableWhen="mobile">
                        {tag == "refer_a_friend_amazon_2021" ? 
                            <BlockContent bleed="none">
                                <LocaleImage style={{maxHeight: `${rem(285)}`}} url="https://dnjpbxg2wcpr8.cloudfront.net/web/locale/refer_a_friend_amazon_gift_card_2021/" ext="png" />
                            </BlockContent>
                        :
                            <BlockContent bleed="none" verticalAlignment="end-no-padding">
                                <LocaleImage style={{maxHeight: `${rem(585)}`, marginBottom: rem(-100)}} url="https://dnjpbxg2wcpr8.cloudfront.net/web/locale/refer_a_friend_devices_2021/" ext="png" />
                            </BlockContent>
                        }
                    </DisabledContent>
                </Block>
            </ContentWrapper>
        </SectionWrapper>
    )
}
